import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button } from '@chakra-ui/react';
import { getSubmitButtonOptions } from '@rjsf/utils';
export default function SubmitButton({ uiSchema }) {
    const { submitText, norender, props: submitButtonProps } = getSubmitButtonOptions(uiSchema);
    if (norender) {
        return null;
    }
    return (_jsx(Box, { marginTop: 3, children: _jsx(Button, { type: 'submit', variant: 'solid', ...submitButtonProps, children: submitText }) }));
}
//# sourceMappingURL=SubmitButton.js.map